import { displayFormattedTotalTimelog } from "../../utils/helpers";

const WorkingHoursCard = ({ totalHours }) => {
  return (
    <div className="shadow-md rounded-md py-3 px-4 h-full min-h-0 lg:min-h-24  w-full">
      <div className="flex">
        <i className="fa-light fa-clock text-primary text-3xl"></i>
        <div className="ml-2 mt-2">
          <p className="font-normal text-dark text-sm">Working Hours</p>
          <p className="text-sm mt-1 text-primary">{displayFormattedTotalTimelog(totalHours)}</p>
        </div>
      </div>
    </div>
  );
};

export default WorkingHoursCard;
